import React from 'react'
import { useTranslate } from 'react-admin'
import { CatalogHeaderRoot, CatalogSubtitle, CatalogTitle } from './utilityTariffCatalogStyles'
import { UtilityTariffsDatabaseSubtitle } from './UtilityTariffsDatabaseSubtitle'

type UtilityTariffCatalogHeaderProps = {
  defaultTitle?: string
  title?: string | React.ReactElement
}

export const UtilityTariffCatalogHeader = ({ defaultTitle, title }: UtilityTariffCatalogHeaderProps) => {
  const translate = useTranslate()
  const heading =
    typeof title === 'string' ? translate(title, { _: title }) : title ? null : defaultTitle

  return (
    <CatalogHeaderRoot>
      {typeof title === 'object' && title != null
        ? title
        : heading != null && <CatalogTitle>{heading}</CatalogTitle>}
      <CatalogSubtitle variant="body2">
        <UtilityTariffsDatabaseSubtitle />
      </CatalogSubtitle>
    </CatalogHeaderRoot>
  )
}
